import { render, staticRenderFns } from "./FilmStaticData.vue?vue&type=template&id=5bdc208b&scoped=true"
import script from "./FilmStaticData.vue?vue&type=script&lang=ts"
export * from "./FilmStaticData.vue?vue&type=script&lang=ts"
import style0 from "./FilmStaticData.vue?vue&type=style&index=0&id=5bdc208b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdc208b",
  null
  
)

export default component.exports